import { Component } from 'shimmer'

export class ToCanvas extends Component {
  constructor ({ image = '', video = '', width = 1920, height = 1080 }) {
    super()

    this.imageUrl = image
    this.videoUrl = video
    this.targetWidth = width
    this.targetHeight = height
    this.media = null
    this.canvas = document.createElement('canvas')

    // document.body.appendChild(this.canvas)

    this.onLoadImage = this.onLoadImage.bind(this)
    this.onLoadVideo = this.onLoadVideo.bind(this)
    this.start = this.start.bind(this)
    this.play = this.play.bind(this)
    this.pause = this.pause.bind(this)
    this.onResize = this.onResize.bind(this)
    this.isPlaying = false

    if (this.imageUrl) {
      this.promise = this.createImage()
    }

    if (this.videoUrl) {
      this.promise = this.createVideo()
    }
  }

  createImage () {
    this.image = new Image(this.imageUrl)
    this.image.crossOrigin = 'anonymous'
    this.image.src = this.imageUrl
    this.media = this.image

    return new Promise((resolve, reject) => {
      this.image.addEventListener('load', () => {
        this.onLoadImage()
        resolve()
      })
    })
  }

  createVideo () {
    this.video = document.createElement('video')
    this.video.crossOrigin = 'anonymous'
    this.video.loop = true
    this.video.muted = true
    this.video.playsinline = true
    this.video.src = this.videoUrl
    this.video.load()
    // this.video.play()
    this.media = this.video
    return new Promise((resolve, reject) => {
      this.video.addEventListener('loadedmetadata', event => {
        this.onLoadVideo(event)
        resolve()
      })
    })
  }

  onLoadVideo (event) {
    this.width = event.target.videoWidth
    this.height = event.target.videoHeight

    this.canvas.width = this.targetWidth ? this.targetWidth : this.width
    this.canvas.height = this.targetHeight ? this.targetHeight : this.height

    this.ctx = this.canvas.getContext('2d')
    this.onResize()
  }

  onLoadImage () {
    this.width = this.image.naturalWidth
    this.height = this.image.naturalHeight

    this.canvas.width = this.targetWidth ? this.targetWidth : this.width
    this.canvas.height = this.targetHeight ? this.targetHeight : this.height

    this.ctx = this.canvas.getContext('2d')
    this.onResize()
  }

  onResize () {
    if (!this.ctx || !this.media) {return}

    this.ctx.fillRect(0, 0, this.width, this.height )

    this._size = this.computeSize(this.width, this.height, this.targetWidth, this.targetHeight)

    if ( this.image ) {
      this.ctx.drawImage(this.media, this._size.offsetX, this._size.offsetY, this._size.width, this._size.height)
    }
  }

  onUpdate () {
    if (!this.media || !this._size || !this.video) {return}

    if ( this.video.readyState === this.video.HAVE_ENOUGH_DATA && this.isPlaying ) {
      this.ctx.drawImage(this.media, this._size.offsetX, this._size.offsetY, this._size.width, this._size.height)
    }
  }

  start () {
    if (this.video) {
      this.video.currentTime = 0
      this.video.play()
      this.video.autoplay = true
      this.isPlaying = true
      // return new Promise(resolve => {
      //   this.video.addEventListener('ended', () => {
      //     this.video.pause()
      //     this.isPlaying = false
      //     this.video.currentTime = this.video.duration
      //     resolve()
      //   })
      // })
    }
    else {
      return new Promise(resolve => {
        resolve()
      })
    }
  }

  play () {
    this.video.play()
  }

  pause () {
    this.video.pause()
  }

  computeSize (contentWidth, contentHeight, containerWidth, containerHeight) {
    const contentRatio = contentWidth / contentHeight
    const containerRatio = containerWidth / containerHeight
    let resultHeight = 0
    let resultWidth = 0

    const offsetX = 0.5
    const offsetY = 0.5

    if (contentRatio > containerRatio) {
      resultHeight = containerHeight
      resultWidth = containerHeight * contentRatio
    }
    else {
      resultWidth = containerWidth
      resultHeight = containerWidth / contentRatio
    }
    return {
      width: resultWidth,
      height: resultHeight,
      offsetX:(containerWidth - resultWidth) * offsetX,
      offsetY: (containerHeight - resultHeight) * offsetY
    }
  }
}